module.exports = __webpack_public_path__ + "static/img/市场现状1.ac1a2c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/市场现状1.jpg
// module id = Exei
// module chunks = 1